export const info = {
  dispoCopy: '',
  errors: '',
  version: '1.3',
};
